<template>
  <div class="isp-sim-container">
    <div class="chart-container">
      <div class="pie">
        <div class="chart-title">{{ $t('dms_ispSimList.SIMka_zhuang_tai') }}</div>
        <div class="chart-pie" ref="pie"></div>
      </div>
      <div class="bar">
        <div class="chart-title">{{ $t('dms_ispSimList.SIMka_ji_huo_qu_shi') }}</div>
        <div class="chart-right">
          <custom-select style="width: 126px; margin-right: 8px" :placeholder="$t('dms_ispSimList.qxzgys')" code="dms_sim_supplier_name" v-model="formSearch.supplierName" @change="changeLineHandler"></custom-select>
          <custom-select style="width: 100px; margin-right: 8px" :placeholder="$t('dms_ispSimList.ISTdi_qu')" code="dms_sim_region_code" v-model="formSearch.lastRegionCode" @change="changeLineHandler"></custom-select>
          <custom-select style="width: 100px; margin-right: 8px" :placeholder="$t('dms_ispSimList.suo_shu_guo_jia')" code="dms_sim_country_code" v-model="formSearch.lastCountryCode" @change="changeLineHandler"></custom-select>
          <el-date-picker style="width: 96px; margin-right: 8px" v-model="year" type="year" :picker-options="pickerOptions" @change="changeLineHandler"></el-date-picker>
          <el-button class="table-set" style="width: 32px; min-width: 32px; padding: 0" @click="exportDialog = true">
            <i style="color: #0d9ae0; font-size: 16px" class="icon icon-daochu"></i>
          </el-button>
        </div>
        <div class="chart-line" ref="line">
          <chart-line :lineData="lineData"></chart-line>
        </div>
      </div>
    </div>
    <div class="operation-record-page" v-if="funcView.isp_sim_list_list">
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item style="float: right; margin-right: 0" v-if="funcView.isp_sim_list_export">
            <el-button class="table-set" @click="exportTable">
              <i class="icon icon-daochu"></i>
            </el-button>
          </el-form-item>
          <!-- 配置项 -->
          <el-form-item style="float: right" :class="{ 'mr-0': !funcView.isp_sim_list_export }">
            <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
          </el-form-item>
          <!-- 搜索项 -->
          <el-form-item style="float: right">
            <search-input v-model="formSearch.search" placeholder="IMSI/ICCID" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
          <el-form-item style="float: right">
            <switch-button :link="link"></switch-button>
          </el-form-item>
          <el-form-item v-if="funcView.isp_sim_list_import">
            <el-button @click="showSimStateDialog">{{ funcView.isp_sim_list_import }}</el-button>
          </el-form-item>
          <el-form-item v-if="funcView.isp_sim_list_country_batch">
            <el-button @click="addBatchCountry">{{ funcView.isp_sim_list_country_batch }}</el-button>
          </el-form-item>
          <el-form-item v-if="funcView.isp_sim_list_edit_country">
            <el-button @click="onEditCountry" :disabled="tableSelect.length == 0">{{ funcView.isp_sim_list_edit_country }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
        <el-form :inline="true" label-position="top">
          <el-form-item :label="$t('dms_ispSimList.zhsysj')">
            <custom-date-picker style="width: 100%" v-model="formSearch.lastUseTime" type="daterange" align="right" value-format="YYYY-MM-DD HH:mm:ss"></custom-date-picker>
          </el-form-item>
          <el-form-item :label="$t('dms_ispSimList.zhjhsj')">
            <custom-date-picker style="width: 100%" v-model="formSearch.lastActiveTime" type="daterange" align="right" value-format="YYYY-MM-DD HH:mm:ss"></custom-date-picker>
          </el-form-item>
          <!-- <el-form-item :label="$t('p_ispSimispSimList_supplierName')">
            <el-input v-model="formSearch.supplierName" :placeholder="$t('p_ispSimispSimList_supplierName')"></el-input>
          </el-form-item> -->
          <el-form-item :label="$t('dms_ispSimList.yun_ying_shang')">
            <el-input v-model="formSearch.isp" :placeholder="$t('dms_ispSimList.yun_ying_shang')"></el-input>
          </el-form-item>
        </el-form>
      </switch-container>
      <div class="table-bd">
        <custom-table
          height="100%"
          v-model="tableSelect"
          type="checkbox"
          :data="tableList"
          :column="tableColumn"
          :index="true"
          @filter="filterChange"
          @sort="sortChange"
          :slots="['lastSessionSendData', 'lastSessionRecvData', 'monthRecvLen']"
        >
          <template v-slot:lastSessionSendData="scope">
            {{ formatDataFlow(scope.row.lastSessionSendData) }}
          </template>
          <template v-slot:lastSessionRecvData="scope">
            {{ formatDataFlow(scope.row.lastSessionRecvData) }}
          </template>
          <template v-slot:monthRecvLen="scope">
            {{ formatDataFlow(scope.row.monthRecvLen) }}
          </template>
        </custom-table>
      </div>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
      <country-batch-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onPageChange({ page: 1 })"></country-batch-dialog>
      <import-sim-state-dialog
        v-if="importSimStateDialogVisible"
        @close="importSimStateDialogVisible = false"
        :model="importSimStateDialogModel"
        @success="onPageChange({ page: 1 })"
      ></import-sim-state-dialog>
      <change-isp-country-dialog v-if="editCountryVisible" @close="editCountryVisible = false" :model="editCountryModel" @success="onPageChange({ page: 1 })"></change-isp-country-dialog>
      <export-ispsim-dialog v-if="exportDialog" :formSearch="formSearch" @close="exportDialog = false"></export-ispsim-dialog>
    </div>
  </div>
</template>

<script>
import G2 from 'G2';
import insertCss from 'insert-css';
import DataSet from '@antv/data-set';
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
import countryBatchDialog from './children/country_batch_dialog.vue';
import importSimStateDialog from './children/import_isp_sim_state_dialog';
import changeIspCountryDialog from './children/change_isp_country_dialog';
import exportIspsimDialog from './children/export_ispsim_dialog';
import chartLine from './children/chart_line';

insertCss(`
    .pie-guide-html {
        width: 100px;
        height: 80px;
        vertical-align: middle;
        text-align: center;
        line-height: 0.2;
    }

    .pie-guide-html .title {
        font-size: 12px;
        color: #8c8c8c;
        font-weight: 300;
    }

    .pie-guide-html .value {
        font-size: 12px;
        color: #000;
        font-weight: bold;
        padding-left: 10px;
    }
`);

export default {
  name: 'ispSimList',
  mixins: [resetFormSearchMixins],
  components: {
    exportIspsimDialog,
    chartLine,
    countryBatchDialog,
    importSimStateDialog,
    changeIspCountryDialog,
  },
  data() {
    return {
      tableCode: 'isp_sim',
      productId: '',
      productTotal: 0,

      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        // 最后使用时间
        lastUseTime: [],
        // 最后激活时间
        lastActiveTime: [],
        // 所属国家
        lastCountryCode: '',
        // 供应商
        supplierName: '',
        // IST地区
        lastRegionCode: '',
        // 运营商
        isp: '',
      },
      pieData: {},
      lineData: [],
      year: new Date(),
      tableSelect: [],
      tableList: [],
      totalRows: null,
      link: null,
      exportDialog: false,
      // 导入
      dialogVisible: false,
      dialogModel: {},
      pickerOptions: {
        firstDayOfWeek: 1,
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },

      importSimStateDialogVisible: false,
      importSimStateDialogModel: {},

      // 编辑国家
      editCountryVisible: false,
      editCountryModel: {},
    };
  },
  activated: function () {
    // this.getTableList();
  },
  computed: {},
  watch: {},
  mounted() {
    this.resetForm = JSON.stringify(this.form);
    this.resetFormSearch = JSON.stringify(this.formSearch);

    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
    this.getPieData().then((data) => {
      this.pieData = data;
      this.drawPie();
    });
    this.getLineData();
    this.getTableColumn();
    this.getTableList();
  },
  methods: {
    changeLineHandler() {
      this.onPageChange({ page: 1 });
      this.getLineData();
    },
    // 获取折线图数据
    getLineData() {
      this.$getJSON(apis.simIspMonthCounts, {
        year: this.year.getFullYear(),
        supplierName: this.formSearch.supplierName,
        lastRegionCode: this.formSearch.lastRegionCode,
        lastCountryCode: this.formSearch.lastCountryCode,
      }).then((res) => {
        this.lineData = res.data;
      });
    },
    // 获取饼图数据
    getPieData() {
      return this.$getJSON(apis.simIspTotalActivateCounts, {}).then((res) => res.data);
    },
    // 饼图
    drawPie() {
      const allText = this.$t('Common.com_all');
      const { activated, unActivated, invalid, stop, unknown, allCount } = this.pieData;
      const data = [
        {
          type: this.$t('dms_ispSimList.yi_ji_huoo', [activated]),
          percent: activated,
          color: 'rgb(61 204 166)',
        },
        {
          type: this.$t('dms_ispSimList.wei_ji_huoo', [unActivated]),
          percent: unActivated,
          color: 'rgba(73, 157, 242, 1)',
        },
        {
          type: this.$t('dms_ispSimList.yi_ting_yongo', [stop]),
          percent: stop,
          color: 'rgba(220, 224, 0, 1)',
        },
        {
          type: this.$t('dms_ispSimList.yi_shi_xiaoo', [invalid]),
          percent: invalid,
          color: 'rgba(224, 224, 224, 1)',
        },
        {
          type: this.$t('dms_ispSimList.wei_zhio', [unknown]),
          percent: unknown,
          color: '#FF5C5B',
        },
      ];
      const sum = allCount;
      const ds = new DataSet();
      const dv = ds.createView().source(data);

      const chart = new G2.Chart({
        container: this.$refs.pie,
        forceFit: true,
        height: 210,
        width: 300,
        padding: 'auto',
      });
      chart.source(dv);
      chart.tooltip(false);
      chart.legend({
        position: 'right-center',
        offsetX: -90,
        offsetY: 10,
        itemMarginBottom: 20,
      });
      chart.coord('theta', {
        radius: 0.75,
        innerRadius: 0.73,
      });
      chart
        .intervalStack()
        .position('percent')
        .color(
          'type',
          data.map((item) => item.color)
        )
        .opacity(1)
        .style({
          stroke: 'white',
          lineWidth: 1,
        })
        .label('percent', {
          offset: -18,
          textStyle: {
            fill: 'white',
            fontSize: 12,
            shadowBlur: 2,
            shadowColor: 'rgba(0, 0, 0, .45)',
          },
          rotate: 0,
          autoRotate: false,
          formatter: () => '',
        });
      // chart.guide();
      chart.guide().html({
        position: ['86%', '25%'],
        html: `<div class="pie-guide-html"><span class="title">${allText}</span><span class="value">${sum}</span></div>`,
      });
      chart.render();
    },
    // 导入国家
    addBatchCountry() {
      this.dialogVisible = true;
    },
    // 获取格式流量
    // byte 转 kb
    formatDataFlow(val) {
      if (!val) {
        return 0;
      }

      const intVal = parseInt(val, 10);

      return Math.round(intVal / 1024);
    },
    // 编辑国家
    onEditCountry() {
      this.editCountryModel = {
        title: this.$t('dms_ispSimList.bian_ji_guo_jia'),
        data: this.tableSelect,
      };
      this.editCountryVisible = true;
    },
    // 导入SIM state
    showSimStateDialog() {
      this.importSimStateDialogModel = {
        title: this.$t('dms_ispSimList.pldrSIMzt'),
      };
      this.importSimStateDialogVisible = true;
    },
    exportTable() {
      const reqData = {
        ...this.formSearch,
      };
      delete reqData.pageSize;
      delete reqData.pageNum;

      this.$exportFlie(apis.simIspExport, reqData);
    },
    getTableListReqData() {
      const ret = {
        ...this.formSearch,
      };

      const lastUseTime = ret.lastUseTime;
      if (lastUseTime && lastUseTime.length) {
        const lastUseStartTime = lastUseTime[0];
        const lastUseEndTime = lastUseTime[1];
        ret.lastUseStartTime = lastUseStartTime;
        ret.lastUseEndTime = lastUseEndTime;
      }

      delete ret.lastUseTime;

      const lastActiveTime = ret.lastUseTime;
      if (lastActiveTime && lastActiveTime.length) {
        const lastActivateStartTime = lastActiveTime[0];
        const lastActivateEndTime = lastActiveTime[1];
        ret.lastActivateStartTime = lastActivateStartTime;
        ret.lastActivateEndTime = lastActivateEndTime;
      }

      delete ret.lastUseTime;

      return ret;
    },
    // 获取列表
    getTableList: function () {
      const reqData = this.getTableListReqData();
      this.$getJSON(apis.simIspPage, reqData).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';

.isp-sim-container {
  padding: 16px;
  padding-bottom: 0;
  display: flex;
  height: 100%;
  flex-direction: column;

  .chart-container {
    height: 280px;
    display: flex;
    justify-content: space-between;

    .chart-title {
      position: absolute;
      z-index: 1000;
      color: #495057;
      font-size: 12px;
      line-height: 28px;
      font-weight: bold;
      top: 16px;
      left: 24px;
    }

    .pie {
      height: 280px;
      width: 400px;
      background: #fff;
      position: relative;

      .chart-pie {
        overflow: hidden;
        position: relative;
        left: -68px;
        top: 48px;
      }
    }

    .chart-line {
      margin-left: 20px;
      margin-right: 20px;
      margin-top: 60px;
      position: relative;
      height: 220px;
      .sheet {
        width: 100%;
        height: 100%;
        position: relative;
      }
    }

    .bar {
      position: relative;
      flex: 1;
      background: #fff;
      height: 100%;
      margin-left: 16px;
      .chart-bar {
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 62px;
        position: relative;
        height: 200px;
      }
      .supplier-search {
        position: absolute;
        right: 148px;
        top: 16px;
        width: 180px !important;
      }
      .year-picker {
        position: absolute;
        right: 24px;
        top: 16px;
        width: 100px;
      }
      .chart-right {
        position: absolute;
        right: 16px;
        display: flex;
        align-items: center;
        height: 56px;
      }
    }
  }

  .operation-record-page {
    background: #fff;
    margin-top: 16px;
    padding: 0 16px;
    display: flex;
    overflow: hidden;
    flex-direction: column;
    flex: 1;
  }
}
</style>
